export default __webpack_public_path__ + "static/media/ClubMaster.94f694015d430bb05819654d3427a08e.webp";